// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GlobalRuleDropdownView___kOZVG{color:#141413}\n", "",{"version":3,"sources":["webpack://./src/components/Table/TableDropdown/TableDropDown.css"],"names":[],"mappings":"AAAA,gCACI,aAAA","sourcesContent":[".GlobalRuleDropdownView {\n    color: #141413;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GlobalRuleDropdownView": "GlobalRuleDropdownView___kOZVG"
};
export default ___CSS_LOADER_EXPORT___;
